// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__fajxL","closeModalIcon":"PopUpModal_closeModalIcon__sKKVA"};